import { createReducer } from "@reduxjs/toolkit";
import { ICustomer } from "../../types/salesOrder.types";
import { customerReceivedCreator } from "../actions/customer";

export const customerReducer = createReducer<ICustomer | null>(null, {
    [customerReceivedCreator.type]: (customer, action) => action.payload,
});
